import React, { Component } from 'react';
import MuiAutoComplete from 'material-ui/AutoComplete';
import LinearProgress from 'material-ui/LinearProgress';

class AutoComplete extends Component {

    setSearchTerm(term) {
        setTimeout( () => { this.refs['complete'].setState({searchText: term}); });
    }
    
    render() {

        const {isFetching, ...props} = this.props;

        return (
            <div>
                <MuiAutoComplete
                    {...props}
                    ref="complete"
                    className="input-field text"
                    fullWidth={true}
                    filter={MuiAutoComplete.caseInsensitiveFilter}
                />
                {!!isFetching && <LinearProgress mode="indeterminate"/>}
            </div>
        );
    }
}

export default AutoComplete;
